import {
    Box,
    BoxProps,
    InternalStandardProps,
    List,
    ListItemButton,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Layout } from "../Layout";
import { AppTypography } from "JS/React/Components/AppTypography";
import { useNavigate } from "react-router-dom";
import { useRouting } from "JS/React/Hooks/Routes";
import { Fragment } from "react";
import { AppHeader } from "JS/React/Components/AppHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useGlobalNavStack } from "JS/React/Hooks/NavStack";
import { AppDivider } from "JS/React/Components/AppDivider";
import { config } from "JS/Config";

const AppInfoRoot = styled(Box)({});

const Grey600Text = styled(AppTypography)(({ theme }) => ({
    color: theme.palette.grey[600],
}));

const StyledListItem = styled(ListItemButton)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
});

const ListTitle = styled(Grey600Text)({
    fontWeight: 400,
    width: "90%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
});

const ListIconsWrapper = styled(Box)({
    width: "5%",
});

const StyledList = styled(List)({
    flexGrow: 1,
});

const ForwardIcon = styled(FontAwesomeIcon)(({ theme }) => ({
    color: `${theme.palette.common.black}`,
}));

export enum AppInfoTypes {
    TERMS_AND_CONDTIONS = "Terms & Conditions of Use",
    PRIVACY_POLICY = "Privacy Policy",
    LICENSE_AGREEMENT = "End User License Agreement",
    EVENT_REGISTRATION_DISCLOURSE = "Event Registration Disclosure",
}

export enum AppInfoEndpoints {
    TERMS_AND_CONDTIONS = "/downloads/media_term_and_condition",
    PRIVACY_POLICY = "/downloads/ltd_privacy_policy",
    LICENSE_AGREEMENT = "/downloads/media_user_licence",
    REGISTRATION_DISCLOURSE = "/downloads/event_registration_disclosure",
}

export interface AppInfoProps extends InternalStandardProps<BoxProps> {}

export const AppInfo = (props: AppInfoProps) => {
    const { className, ...rest } = props;
    const { homeStack } = useGlobalNavStack();
    const navigate = useNavigate();
    const { linkProvider } = useRouting();

    const handleNavigate = (
        e: React.MouseEvent<HTMLDivElement, MouseEvent>,
        key: string,
    ) => {
        const baseUrl = config.feedbackBaseApiUrl;
        switch (key) {
            case AppInfoTypes.TERMS_AND_CONDTIONS:
                window.open(
                    baseUrl + AppInfoEndpoints.TERMS_AND_CONDTIONS,
                    "_self",
                );

                break;
            case AppInfoTypes.PRIVACY_POLICY:
                window.open(baseUrl + AppInfoEndpoints.PRIVACY_POLICY, "_self");
                break;
            case AppInfoTypes.LICENSE_AGREEMENT:
                window.open(
                    baseUrl + AppInfoEndpoints.LICENSE_AGREEMENT,
                    "_self",
                );
                break;
            case AppInfoTypes.EVENT_REGISTRATION_DISCLOURSE:
                window.open(
                    baseUrl + AppInfoEndpoints.REGISTRATION_DISCLOURSE,
                    "_self",
                );
                break;
            default:
                break;
        }
    };

    return (
        <Layout>
            <AppInfoRoot
                {...rest}
                className={className}
                display={"flex"}
                flexDirection={"column"}
                height={"100%"}
            >
                <AppHeader
                    title={"App Info"}
                    canGoBack
                    searchable={false}
                    onBackClick={() => {
                        if (!homeStack?.isHomeTrack) {
                            navigate(linkProvider.react.more().index());
                        } else {
                            navigate(linkProvider.react.home());
                        }
                    }}
                />
                <StyledList>
                    {Object.keys(AppInfoTypes).map((key, idx) => (
                        <Fragment key={`${idx}-${key}`}>
                            <StyledListItem
                                onClick={(e) =>
                                    handleNavigate(e, AppInfoTypes[key])
                                }
                            >
                                <ListTitle variant="h6">
                                    {AppInfoTypes[key]}
                                </ListTitle>
                                <ListIconsWrapper>
                                    <ForwardIcon
                                        icon={["fas", "chevron-right"]}
                                    />
                                </ListIconsWrapper>
                            </StyledListItem>
                            <AppDivider />
                        </Fragment>
                    ))}
                </StyledList>
            </AppInfoRoot>
        </Layout>
    );
};
